// extracted by mini-css-extract-plugin
export var container = "_9p-0";
export var icon = "_9p-1";
export var text = "_9p-2";